/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  ActionLogDTO,
  Address,
  AddressInfoDTO,
  AddressJudgmentResult,
  AddressVerifyRequest,
  AddressVerifyResponse,
  AiCargoDTO,
  AiResultResponse,
  AllocateDTO,
  AllocateRequest,
  BatchAllocateRequest,
  BizOperRequest,
  BizOperResponse,
  CancelShipmentRequest,
  CarParamConfigDTO,
  CarrierCountDTO,
  CarrierCountResponse,
  CityDTO,
  CommissionAuditRequest,
  CompanyAddRequest,
  CompanyAuditRequest,
  CompanyDetailResponse,
  CompanyEditRequest,
  CompanyPageResponse,
  CompanyQueryRequest,
  CompanyStatusRequest,
  CreditEditRequest,
  CustomPlatformConfigPageResponse,
  CustomPlatformConfigQueryRequest,
  CustomPlatformConfigRequest,
  CustomPlatformConfigResponse,
  CustomerCreditResponse,
  CustomerFtlQuoteConfigDTO,
  CustomerQuoteConfigDTO,
  CustomerQuoteInfoDTO,
  CustomerQuoteInfoDetailDTO,
  CustomerQuoteServiceDetailDTO,
  CustomerResponse,
  DriverAddRequest,
  DriverDetailResponse,
  DriverInfoDTO,
  DriverPageResponse,
  DriverQueryRequest,
  DriverStatusRequest,
  ExceptionDealDetailResponse,
  ExceptionDealRequest,
  ExceptionDetailResponse,
  ExceptionPageResponse,
  ExceptionQueryRequest,
  FCashOutApproveRequest,
  FCashOutListResponse,
  FCashOutQueryRequest,
  FCashOutResponse,
  FCustomerWalletRequest,
  FCustomerWalletResponse,
  FHistoryBillRequest,
  FRechargeApproveRequest,
  FRechargeListResponse,
  FRechargeQueryRequest,
  FRechargeRequest,
  FRechargeResponse,
  FTradeRequest,
  FTransactionResponse,
  FWalletResponse,
  FmcsaCarrier,
  FmcsaCarrierListVO,
  FmcsaQueryRequest,
  FmcsaReamrkResponse,
  FmcsaStatusRequest,
  FreightClassRequest,
  FtlAcceptRequest,
  FtlAddStopRequest,
  FtlAddressIdDTO,
  FtlAddressResponse,
  FtlAmountDTO,
  FtlCargoDTO,
  FtlExactAddressDTO,
  FtlExactQuoteRequest,
  FtlOrderAmountRequest,
  FtlOrderAmountResponse,
  FtlOrderBackRequest,
  FtlOrderBatchIdRequest,
  FtlOrderCreateRequest,
  FtlOrderDetailExtResponse,
  FtlOrderDriverUpdateRequest,
  FtlOrderListExtResponse,
  FtlOrderPickDateRequest,
  FtlOrderPriceUpdateRequest,
  FtlOrderQueryRequest,
  FtlOrderRefNumberUpdateRequest,
  FtlOrderRemarkUpdateRequest,
  FtlQuoteConfigDTO,
  FtlQuoteConfigPageResponse,
  FtlQuoteConfigQueryRequest,
  FtlQuoteConfigRequest,
  FtlQuoteConfigResponse,
  FtlQuoteInfoDTO,
  FtlQuoteInfoDetailDTO,
  FtlQuoteResponse,
  FtlQuoteResultDTO,
  FtlRearrangeRequest,
  FtlStopFeeInfoDTO,
  FtlWaybillAllocateRequest,
  FtlWaybillAmountRecordDTO,
  FtlWaybillAmountUpdateRequest,
  FtlWaybillBolNoUpdateRequest,
  FtlWaybillDetailResponse,
  FtlWaybillListResponse,
  FtlWaybillPriceRequest,
  FtlWaybillPriceResponse,
  FtlWaybillRemarkUpdateRequest,
  FtlWaybillStatusRequest,
  FtlWaybillTrackLogResponse,
  FtlWaybillUpdateRequest,
  HazardInfoDTO,
  HelperInfoReqeust,
  IPage,
  LocalTime,
  LocalTimeReq,
  LocalTimeRes,
  MailQuoteConfigResponse,
  MainQuoteConfigPageResponse,
  MainQuoteConfigQueryRequest,
  MainQuoteConfigRequest,
  OrderAcceptRequest,
  OrderActionLogResponse,
  OrderAddressDTO,
  OrderAddressDTOReq,
  OrderAddressDTORes,
  OrderAmountRecordDTO,
  OrderAmountRequest,
  OrderAmountResponse,
  OrderBatchIdRequest,
  OrderBidPriceRequest,
  OrderBillToVo,
  OrderCargoDTO,
  OrderCountDTO,
  OrderCountResponse,
  OrderDetailResponse,
  OrderFileRequest,
  OrderListExtResponse,
  OrderPickDateRequest,
  OrderPickupInfoRequest,
  OrderPriceUpdateRequest,
  OrderQueryRequest,
  OrderQuoteDTO,
  OrderQuoteRequest,
  OrderQuoteResultResponse,
  OrderRefNumberUpdateRequest,
  OrderRequest,
  OrderSimpleCargoDTO,
  OrderSimpleInfoDTO,
  OrderTrackingDTO,
  OssFileResponse,
  OwnerQueryRequest,
  OwnerUserAuditRequest,
  OwnerUserEditRequest,
  OwnerUserLevelRequest,
  OwnerUserPwdRequest,
  OwnerUserRequest,
  OwnerUserResponse,
  PackageItemsDTO,
  PageQuery,
  PlaceDetailResponse,
  PlaceResultDTO,
  PlaceResultResponse,
  PlaceSearchRequest,
  PlatformCommodityDTO,
  PlatformConfigDetailDTO,
  PlatformOrderCoreRequest,
  PlatformQuoteRateDTO,
  PlatformRateDetailDTO,
  QueryCityPageDTO,
  QueryQuoteAmountDTO,
  QuoteConfigDTO,
  QuoteConfigUpdateDTO,
  QuoteConfigUpdateRequest,
  QuoteInfoDTO,
  QuoteInfoDetailDTO,
  QuoteOrderPriceDTO,
  QuoteResultResponse,
  QuoteServiceDetailDTO,
  RouteDetailResponse,
  R,
  SalesAmountReportResponse,
  SalesCustomerRequest,
  SalesCustomerResponse,
  SalesDetailResponse,
  SalesOrderCountRequest,
  SalesOrderRequest,
  SalesOrderResponse,
  SalesQueryRequest,
  SalesSimpleResponse,
  SalesUserRequest,
  SalesUserResponse,
  SalesUserStatusVo,
  ServiceExtraQuoteDetailDTO,
  ServiceQuoteConfigRequest,
  ServiceQuoteConfigResponse,
  ServiceQuoteConfigUpdateRequest,
  ServiceQuoteDetailDTOReq,
  ServiceQuoteDetailDTORes,
  ShipmentCountResponse,
  ShipmentDetailExtResponse,
  ShipmentPageExtResponse,
  ShipmentQueryRequest,
  ShipmentTrackResponse,
  SimpleDriverListResponse,
  SimpleDriverQueryRequest,
  SimpleTruckListResponse,
  SimpleTruckQueryRequest,
  SysDepartmentTreeVo,
  SysDepartmentVo,
  SysPermission,
  SysPermissionTreeVo,
  SysPermissionVo,
  SysRoleResultVo,
  SysRoleVo,
  SysUserPasswordVo,
  SysUserQueryVo,
  SysUserStatusVo,
  SysUserVo,
  TimeZoneDTO,
  TrackInfo,
  TrackQueryRequest,
  TransferCenterQueryRequest,
  TransferCenterRequest,
  TransferCenterResponse,
  TranslateRequest,
  TranslateResponse,
  TruckAddOrEditRequest,
  TruckBindRequest,
  TruckDetailResponse,
  TruckPageQueryRequest,
  TruckPageResponse,
  TruckStatusRequest,
  UpdateBatchIdDTO,
  UpdateQuoteConfigDisableDTO,
  UserInfoVo,
  UserLoginVo,
  WaybillActionLogFileResponse,
  WaybillActionLogResponse,
  WaybillBolNoUpdateRequest,
  WaybillCountDTO,
  WaybillCountResponse,
  WaybillDetailResponse,
  WaybillFileResponse,
  WaybillPriceRecordDTO,
  WaybillPriceRequest,
  WaybillPriceResponse,
  WaybillPriceUpdateRequest,
  WaybillQueryRequest,
  WaybillRemarkUpdateRequest,
  WaybillRouteInfoDTO,
  WaybillRouteResponse,
  WaybillTrackLogResponse,
  WaybillTruckUpdateRequest,
  WaybillUpdateDriverRequest,
  WaybillUpdateRequest,
  WnChannelCommissionDTO,
} from './type';
import request from '@/utils/request';

export class FtlWaybillService {
  // 查看司机操作日志
  public static getFtlActiveLogUsingGET(orderNo: string): Promise<R<OrderActionLogResponse>> {
    return request('GET', '/ftl/waybill/active-log', null, { orderNo }, null, null, null);
  }

  // 分配运单
  public static allocateFtlWaybillUsingPUT(allocateRequest: FtlWaybillAllocateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/waybill/allocate', null, null, allocateRequest, null, null);
  }

  // 取消运单
  public static cancelFtlWaybillUsingPUT(orderNo: string): Promise<R<string>> {
    return request('PUT', '/ftl/waybill/cancel', null, { orderNo }, null, null, null);
  }

  // 运单详情
  public static detailFtlWaybillUsingGET(orderNo: string): Promise<R<FtlWaybillDetailResponse>> {
    return request('GET', '/ftl/waybill/detail', null, { orderNo }, null, null, null);
  }

  // 整车运单导出
  public static exportFtlWaybillUsingPOST(query: WaybillQueryRequest): Promise<void> {
    return request('POST', '/ftl/waybill/export', null, null, query, null, null);
  }

  // 查看bol文件
  public static getFtlWaybillFileUsingGET(orderNo: string, fileType?: number): Promise<R<Array<WaybillFileResponse>>> {
    return request('GET', '/ftl/waybill/getBolFile', null, { fileType, orderNo }, null, null, null);
  }

  // 整车运单列表
  public static pageFtlWaybillUsingPOST(query: WaybillQueryRequest): Promise<R<IPage<FtlWaybillListResponse>>> {
    return request('POST', '/ftl/waybill/page', null, null, query, null, null);
  }

  // 查看路由
  public static getFtlRouteDetailUsingGET_1(orderNo: string): Promise<R<RouteDetailResponse>> {
    return request('GET', '/ftl/waybill/routeDetail', null, { orderNo }, null, null, null);
  }

  // 查看轨迹坐标
  public static getFtlTrackingLocationUsingGET(
    orderNo: string,
    latestId?: number,
  ): Promise<R<Array<OrderTrackingDTO>>> {
    return request('GET', '/ftl/waybill/tracking-location', null, { latestId, orderNo }, null, null, null);
  }

  // 查看轨迹
  public static getFtlWaybillTrackingLogUsingGET(orderNo: string): Promise<R<FtlWaybillTrackLogResponse>> {
    return request('GET', '/ftl/waybill/tracking-log', null, { orderNo }, null, null, null);
  }

  // 查看操作留痕文件
  public static getFtlWaybillTrackingLogFileUsingGET(actionId: number): Promise<R<WaybillActionLogFileResponse>> {
    return request('GET', '/ftl/waybill/tracking-logFile', null, { actionId }, null, null, null);
  }

  // 运单更新-更新司机信息
  public static updateFtlWaybillUsingPUT_1(updateRequest: FtlWaybillUpdateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/waybill/update', null, null, updateRequest, null, null);
  }

  // 更新运单金额
  public static updateFtlWaybillAmountUsingPUT(updateRequest: FtlWaybillAmountUpdateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/waybill/updateAmount', null, null, updateRequest, null, null);
  }

  // 更新bol单号
  public static updateFtlWaybillBolNoUsingPUT(updateRequest: FtlWaybillBolNoUpdateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/waybill/updateBolNo', null, null, updateRequest, null, null);
  }

  // 更新运单备注
  public static updateFtlWaybillRemarkUsingPUT(updateRequest: FtlWaybillRemarkUpdateRequest): Promise<R<string>> {
    return request('PUT', '/ftl/waybill/updateRemark', null, null, updateRequest, null, null);
  }

  // 更新运单
  public static updateFtlWaybillUsingPUT(updateRequest: FtlWaybillStatusRequest): Promise<R<string>> {
    return request('PUT', '/ftl/waybill/updateStatus', null, null, updateRequest, null, null);
  }

  // 列表数量统计
  public static ftlWaybillStatusCountUsingPOST(query: WaybillQueryRequest): Promise<R<WaybillCountResponse>> {
    return request('POST', '/ftl/waybill/waybillStatus', null, null, query, null, null);
  }
}
